import { render, staticRenderFns } from "./ExportProductsPage.vue?vue&type=template&id=d32be10a"
import script from "./ExportProductsPage.vue?vue&type=script&lang=js"
export * from "./ExportProductsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports